<script setup lang="ts">
import type { Bubble } from '@/stores/interfaces'
import BubbleHeader from '@/components/bubbles/BubbleHeader.vue'
import { useTypeNavigation } from '@/composables/useTypeNavigation'

const props = defineProps<{
  bubble: Bubble
}>()

// Use the type navigation composable
useTypeNavigation(props.bubble)
</script>

<template>
  <div class="flex flex-col h-full">
    <BubbleHeader :bubble="bubble" />
    <div class="flex-grow flex items-center justify-center p-4">
      <div class="text-center">
        <h2 class="text-2xl font-bold mb-4">Detailed View Coming Soon!</h2>
        <p class="text-gray-600">We're working on a detailed view for this bubble type.</p>
      </div>
    </div>
  </div>
</template>
